
export default {
    getJwtClaim (token, key) {
        let claim = token ? this.parseJWTToken(token)[key] : null
        return claim
    },
    parseJWTToken (token) {
        let base64Url = token.split('.')[1]
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''))
        return JSON.parse(jsonPayload)
    },
    generateHashFromString(str){
        return str.split('').reduce((prevHash, currVal) =>
          (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
    },
    checkFeatureInRoute(routeFeatures, loadedFeatures){
        if(routeFeatures){
            let allow = false
            Object.entries(routeFeatures).forEach((feature)=>{
                if(loadedFeatures[feature[0]]){
                    allow = true
                }
            })
            return allow
        }else {
            return true
        }
    },
    getLoadingPageRoute(isGlobalAdminHostname, hasBookingFeatures, hasMonitoring, hasComfort){
        if (isGlobalAdminHostname){
            return '/organization/clients'
        }
        if (hasBookingFeatures) {
            return '/organization/user/bookings'
        }
        if (hasMonitoring) {
            return '/desk4me/admin/dashboards/monitoring'
        }
        if (hasComfort) {
            return '/desk4me/admin/dashboards/comfort'
        }
        return '/organization/notFound'
    }
}
